import styled from "styled-components";
import { Grid } from "@mui/material";

export const FormContainer = styled(Grid)`
  margin-top: ${(props): string => props.theme.spacing(-3.9)};
`;
